export const GetDuidBidTypeKey = (duid, bidType) => `${duid}_${bidType}`;
